import { render, staticRenderFns } from "./WasteMerchantAdministrative.vue?vue&type=template&id=c56f507c&scoped=true&"
import script from "./WasteMerchantAdministrative.vue?vue&type=script&lang=js&"
export * from "./WasteMerchantAdministrative.vue?vue&type=script&lang=js&"
import style0 from "./WasteMerchantAdministrative.vue?vue&type=style&index=0&id=c56f507c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f507c",
  null
  
)

export default component.exports